import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    const { stateSelector } = this.element.dataset;
    this.stateSelector = document.querySelector(stateSelector);
    if (!this.stateSelector) return;

    this.requestToken = 0;

    // jQuery handlers also run for native change events, so binding once here
    // covers both a user picking a state and code calling .trigger("change").
    $(this.stateSelector).on("change", this.handleStateSelectorChange)

    this.ready = this.setupAutocomplete();
  }

  disconnect() {
    if (this.stateSelector) {
      $(this.stateSelector).off("change", this.handleStateSelectorChange)
    }

    if (this.autocompleteInstance) {
      this.autocompleteInstance.select2("destroy");
      this.autocompleteInstance = null;
    }
  }

  setupAutocomplete = async () => {
    // Only the newest request may repaint the list: switching states quickly
    // would otherwise let a slower earlier response land last.
    const token = ++this.requestToken;
    const stateFlag = this.stateSelector.value;
    const data = await this.buildSelectOptions(stateFlag);
    if (token !== this.requestToken) return;

    this.applyOptions(data);
  }

  buildSelectOptions = async (state) => {
    if (!state) return [];

    const response = await fetch(`/cities?state=${encodeURIComponent(state)}`);
    if (!response.ok) return [];

    const { cities } = await response.json();
    return cities.map(city => ({ id: city, text: city }));
  }

  applyOptions = (data) => {
    const previousValue = this.element.value;
    // The blank entry keeps the field clearable once the seeded option is gone.
    const options = [{ id: "", text: "" }, ...data];

    // A stored city the list does not know about (legacy data) stays available
    // so that opening a form never silently drops what is already saved.
    if (previousValue && !data.some(({ id }) => id === previousValue)) {
      options.push({ id: previousValue, text: previousValue });
    }

    if (this.autocompleteInstance) {
      this.autocompleteInstance.select2("destroy");
    }

    // Rebuilding from scratch stops cities of a previous state from lingering.
    this.element.innerHTML = "";
    this.autocompleteInstance = $(this.element).select2({ data: options });
    this.autocompleteInstance.val(previousValue).trigger("change");
  }

  handleStateSelectorChange = (_event) => {
    // removing previous value, it belongs to the previous state
    if (this.autocompleteInstance) {
      this.autocompleteInstance.val("").trigger("change");
    } else {
      this.element.value = "";
    }

    // refresh autocomplete
    this.ready = this.setupAutocomplete();
  }
}
